function getWidth() {
  return window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;
};

export default {
  install(Vue, options) {
    Vue.prototype.getAppUrl = () => {
      let url = process.env.VUE_APP_BACKEND_URL;
      return url;
    },
    Vue.prototype.storagePath = () => {
      let url = `${process.env.VUE_APP_BACKEND_URL}/storage`;
      return url;
    },
    Vue.prototype.getApiUrl = () => {
      let url = `${process.env.VUE_APP_BACKEND_URL}/api`;
      return url;
    },

    Vue.prototype.laraPaginate = (data) => {
      let pagination = {}
      let paginate = Object.keys(data).filter(key => {
          return data[key] != data.data
      }).map(key => {
          pagination[key] = data[key]
      })

      return pagination
    },

    Vue.prototype.getIndex = (array, key, value) => {
        return array.findIndex(i => i[key] == value)
    },

    Vue.prototype.laravelValidation = (err) => {
        let errors = {}
        if (err.response) {
            if (err.response.status === 422) {
                errors = err.response.data.errors
            }
            return errors
        }
    },

    Vue.prototype.sidebar_toggle = () => {
        if (getWidth() > 991) {
            jQuery('#page-container').toggleClass('sidebar-o');
        } else {
            jQuery('#page-container').toggleClass('sidebar-o-xs');
        }
    },
    Vue.prototype.sidebar_open = () => {
        if (getWidth() > 991) {
            jQuery('#page-container').addClass('sidebar-o');
        } else {
            jQuery('#page-container').addClass('sidebar-o-xs');
        }
    },
    Vue.prototype.sidebar_close = () => {
        if (getWidth() > 991) {
            jQuery('#page-container').removeClass('sidebar-o');
        } else {
            jQuery('#page-container').removeClass('sidebar-o-xs');
        }
    }
  }
}
